export function Field({ label, error, children, testid }) {
  return (
    <div className="space-y-1.5">
      <label className="block text-[11px] font-semibold uppercase tracking-[0.15em] text-slate-400">{label}</label>
      {children}
      {error && (
        <p data-testid={`${testid}-error`} className="text-xs font-medium text-red-400">
          {error}
        </p>
      )}
    </div>
  );
}

export const inputCls =
  'w-full rounded-lg border border-white/10 bg-ink/70 px-4 py-2.5 text-sm text-white placeholder:text-slate-600 outline-none transition-colors focus:border-pulse/70 focus:ring-2 focus:ring-pulse/20';
